import React from 'react';
import { useSelector } from 'react-redux';
import { getCurrentPageId, getMarker, getPageByIdOrActive, getPageImage, } from 'app/stores/selectors';
import { Image } from 'app/views/components/svg/Image';
import { useConnect } from 'app/views/hooks/useConnect';
import { Marker } from './Marker';
export const Blurs = (props) => {
    const { slideId } = props;
    const image = useSelector((state) => getPageImage(state, slideId !== null && slideId !== void 0 ? slideId : getCurrentPageId(state)));
    const blursMap = useConnect(state => {
        const { blurs } = getPageByIdOrActive(state, slideId);
        if (!blurs || !blurs.length) {
            return null;
        }
        const blurMarkers = blurs.map(id => getMarker(state, id));
        return blurMarkers.reduce((accum, blur) => {
            accum[blur.id] = blur.method;
            return accum;
        }, {});
    });
    const isEmpty = !image || !blursMap;
    if (isEmpty) {
        return null;
    }
    const { blurredImage, size: { width, height }, } = image;
    const ids = Object.keys(blursMap);
    // if there is no pixelation thumbnail draw all as hide
    if (!blurredImage) {
        return (React.createElement("g", null, ids.map(id => (React.createElement(Marker, { key: id, id: id })))));
    }
    const clipId = 'blur-clip';
    // always pixelate ! even under solid 'blurs'
    return (React.createElement("g", null,
        React.createElement("defs", null,
            React.createElement("clipPath", { id: clipId }, ids.map(id => (React.createElement(Marker, { key: id, id: id }))))),
        React.createElement(Image, { src: blurredImage.url, width: width, height: height, clipPath: `url(#${clipId})` }),
        ids
            .filter(id => blursMap[id] === 'solid')
            .map(id => (React.createElement(Marker, { key: id, id: id })))));
};
